import React from 'react';
import { publicBlogRoutes } from './routes';
import RouteRedirect from '../common/RouteRedirect';
import styled from 'styled-components';

const PublicBlogWrapper = styled.div`
  min-height: calc(100vh - 200px);
  background: #f8f9fa;
`;

const Blog = () => {
  return (
    <PublicBlogWrapper>
      <RouteRedirect routes={publicBlogRoutes} redirects={[]} />
    </PublicBlogWrapper>
  );
};

export default Blog;